import { actionType } from "../../helpers/reducers";

export const SETTINGS_TOGGLE_EDITOR_THEME = "settings/TOGGLE_EDITOR_THEME";
export const SETTINGS_DOC_LAST_OPENED = "settings/DOC_LAST_OPENED";
export const SETTINGS_REMOVE_DOC_LAST_OPENED =
    "settings/REMOVE_DOC_LAST_OPENED";

export const toggleEditorTheme = actionType(SETTINGS_TOGGLE_EDITOR_THEME);
export const setDocLastOpened = actionType(SETTINGS_DOC_LAST_OPENED);
export const removeDocLastOpened = actionType(SETTINGS_REMOVE_DOC_LAST_OPENED);
